// extracted by mini-css-extract-plugin
export default {"warning_post":"home_warning_post__hOOIY"};